import React, { useState } from 'react';

const images = [
  'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1534972195531-d756b9bfa9f2?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1462331940025-496dfbfc7564?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1507400492013-162706c8c05e?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1516339901601-2e1b62dc0c45?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1633356122544-f134324a6cee?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?auto=format&fit=crop&w=800&q=80',
];

const prompts = [
  '"A cyberpunk city at sunset with neon lights reflecting on wet streets"',
  '"Ethereal forest with bioluminescent plants and floating particles"',
  '"Majestic mountain range at golden hour with dramatic clouds"',
  '"Futuristic space station orbiting a distant planet"',
  '"Cosmic nebula with vibrant colors and distant stars"',
  '"Northern lights dancing over a frozen landscape"',
  '"Abstract digital art with flowing geometric shapes"',
  '"Underwater city with glowing coral and sea creatures"',
  '"Mystical portal opening in an ancient temple"',
  '"Holographic interface in a sci-fi command center"',
  '"Neural network visualization with glowing nodes"',
  '"Gradient waves of color in abstract composition"',
];

const ImageGenSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isGenerating, setIsGenerating] = useState(false);

  const handleGenerate = () => {
    if (isGenerating) return;
    
    setIsGenerating(true);
    
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
      setIsGenerating(false);
    }, 2000);
  };

  return (
    <div id="image-gen-section" className="mb-16 sm:mb-24">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
        <div className="order-2 lg:order-1">
          <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
            <div className="flex h-10 w-10 sm:h-12 sm:w-12 items-center justify-center rounded-full bg-primary/20">
              <span className="material-symbols-outlined text-primary text-xl sm:text-2xl">image</span>
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-white">AI Image Generation</h3>
          </div>
          <p className="text-white/70 mb-4 sm:mb-6 text-sm sm:text-lg">
            Transform text descriptions into stunning visuals with photorealistic detail. Our AI understands context, style, and composition to create exactly what you envision.
          </p>
          <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
            <li className="flex items-center gap-2 sm:gap-3 text-white/60 text-sm">
              <span className="material-symbols-outlined text-primary text-sm">check_circle</span>
              Text-to-image with natural language prompts
            </li>
            <li className="flex items-center gap-2 sm:gap-3 text-white/60 text-sm">
              <span className="material-symbols-outlined text-primary text-sm">check_circle</span>
              Style transfer and artistic rendering
            </li>
            <li className="flex items-center gap-2 sm:gap-3 text-white/60 text-sm">
              <span className="material-symbols-outlined text-primary text-sm">check_circle</span>
              Upscaling and enhancement up to 8K
            </li>
          </ul>
          <button 
            onClick={handleGenerate}
            disabled={isGenerating}
            className="btn-glow flex h-10 sm:h-12 items-center justify-center rounded-full bg-primary px-6 sm:px-8 text-xs sm:text-sm font-bold text-background-dark disabled:opacity-50"
          >
            {isGenerating ? 'Generating...' : 'Generate'}
          </button>
        </div>
        <div className="order-1 lg:order-2">
          <div className="glass-panel rounded-xl sm:rounded-[2rem] p-4 sm:p-6 relative overflow-hidden">
            <div className="bg-white/5 rounded-lg sm:rounded-xl p-3 sm:p-4 mb-3 sm:mb-4">
              <p className="text-white/40 text-xs sm:text-sm font-mono">{prompts[currentIndex]}</p>
            </div>
            <div className="aspect-video rounded-lg sm:rounded-xl overflow-hidden bg-gradient-to-br from-primary/20 to-amber-900/20 flex items-center justify-center relative">
              {isGenerating ? (
                <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/60 z-10">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin mb-3 sm:mb-4"></div>
                  <p className="text-white/70 text-xs sm:text-sm">Generating your image...</p>
                </div>
              ) : null}
              <img 
                src={images[currentIndex]} 
                alt="AI Generated" 
                className={`w-full h-full object-cover transition-opacity duration-300 ${isGenerating ? 'opacity-30' : 'opacity-100'}`}
              />
            </div>
            <div className="flex items-center justify-between mt-3 sm:mt-4">
              <span className="text-[10px] sm:text-xs text-white/40 font-mono">Generated in 0.8s</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageGenSection;
